import * as React from "react";
import styled from "styled-components";
import Modal from "../ModalWindow/Modal";
import {CSSProperties} from "react";

const Icon = styled.span`
  cursor: pointer;
  vertical-align: text-bottom;
`;

const InfoIcon: React.FC<{style?: CSSProperties; children: React.ReactNode}> = (props) => {
  const [open, setOpen] = React.useState<boolean>(false);

  return (
    <Icon style={props.style} className="Svg Svg-Icon-Info" onClick={() => setOpen(true)}>
      <Modal isVisible={open} closeFunction={() => setOpen(false)}>
        {props.children}
      </Modal>
    </Icon>
  );
};

export default InfoIcon;
